export default "__VITE_ASSET__11ebf7e7__"